import { atom } from "recoil";
import { useDistanceOfPointsEvQuery } from "../../generated/graphql";

// graphql
type DistanceOfPointsEvQueryStateType = Pick<ReturnType<typeof useDistanceOfPointsEvQuery>, 'data' | 'loading'>;
export const distanceOfPointsEvQueryState = atom<DistanceOfPointsEvQueryStateType>({
    key: "distanceOfPointsEvQueryState",
    default: { data: undefined, loading: true } as DistanceOfPointsEvQueryStateType,
});
